module.exports = __webpack_public_path__ + "static/img/ky.5814c5a9.svg";